<script>
    import { apiUrl, stickyScroll, isMobile } from "@/utils";

    export default {
        name: "LiteCompareHeaderMobile",
        props: {
            products: {
                type: Array,
                required: true,
                default: () => [],
            },
            imagesList: {
                type: Object,
                default: () => ({}),
            },
            startPosition: {
                type: Number,
                default: 560,
            },
        },
        mounted() {
            this.$nextTick(() => {
                if (isMobile(992)) {
                    window.addEventListener("scroll", this.stickyComparisonHeaderScroll);
                }
            });
        },
        beforeDestroy() {
            window.removeEventListener("scroll", this.stickyComparisonHeaderScroll);
        },
        methods: {
            stickyComparisonHeaderScroll() {
                let el = this.$refs.scrollComparison;
                let elWrap = this.$refs.scrollComparisonWrap;

                stickyScroll({
                    el,
                    elWrap,
                    topMargin: 46,
                    startPoint: this.startPosition,
                    classNameDivider: "js-stop-scroll-comparison",
                    calcWidth: false,
                });
            },
            getProductImage(product) {
                const staticImage = this.imagesList[product.slug];
                if (staticImage) {
                    return `/static/assets/lite-compare/${this.$_name}/products/${staticImage}?v=170622`;
                }
                return apiUrl(product.offers[0]?.previewImage?.medium);
            },
            apiUrl,
        },
    };
</script>

<template>
    <div class="lite-compare-header-mobile" ref="scrollComparison">
        <div
            class="lite-compare-header-mobile__scroll"
            ref="scrollComparisonWrap"
            data-fix-on-scroll
        >
            <slot></slot>
        </div>
    </div>
</template>

<style lang="scss">
    .lite-compare-header-mobile {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 62px !important;
        margin-top: -62px;
    }

    .lite-compare-header-mobile__scroll {
        left: 0;
        opacity: 0;
        width: 100%;
        padding: 12px 0;
        background: #fff;
        border-bottom: 1px solid #d9e9ed;
        z-index: 25;

        &.fix-scroll-block {
            opacity: 1;
        }
    }
</style>
